import { render, staticRenderFns } from "./RemediationPaymentData.vue?vue&type=template&id=5cd4fd36&scoped=true"
import script from "./RemediationPaymentData.vue?vue&type=script&lang=js"
export * from "./RemediationPaymentData.vue?vue&type=script&lang=js"
import style0 from "./RemediationPaymentData.vue?vue&type=style&index=0&id=5cd4fd36&prod&scoped=true&lang=css"
import style1 from "./RemediationPaymentData.vue?vue&type=style&index=1&id=5cd4fd36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd4fd36",
  null
  
)

export default component.exports